import {
	Beneficiaries,
	BeneficiariesErrors,
	ContractErrorsDTO,
	ContractData,
	CrsDTO,
	FatcaDTO,
	InvestorDTO,
	InvestorErrorsDTO,
	LegalInvestorStatus,
	PhysicalInvestorStatus,
	Representative,
	RepresentativeErrors,
	TaxHolder,
	SuitabilityTestErrors,
	SuitabilityTestResult,
	ExternalContractData,
	ContractPhysicalInvestorDocuments,
	ContractLegalInvestorDocuments,
	InvestorDocuments,
	PhysicalInvestorDocumentsRequest,
} from "../../Models";

export const emptyContract: ContractData = {
	numSignatories: 1,
	idPersonType: 1,
	commitment: 0,
	idInstitution: 0,
	vehicleId: 0,
	id: 0,
	idLanguage: 1,
	idContractState: 1,
	bp: undefined,
	container: undefined,
	isTransfer: false,
	transferReason: undefined,
	idInvestorOrigin: undefined,
	quote: undefined
};

export const emptyContractErrors: ContractErrorsDTO = {
	vehicleId: false,
	commitment: false,
	transferReason: false,
	idInvestorOrigin: false,
	container: false,
	bp: false,
	invalidBP: false,
	invalidContainer: false,
	noTemplate: false
};

export const emptyInvestor: InvestorDTO = {
	id: 0,
	name: "",
	lastName: "",
	birthDate: "",
	birthPlace: "",
	nationality: undefined,
	entityNationality: undefined,
	mainResidence: "",
	mainResidenceCountry: undefined,
	emailContact: "",
	phoneNumber: "",
	phonePrefix: "",
	document: "",
	dni: "",
	nif: "",
	cif: "",
	passport: "",
	residenceCard: "",
	managerName: "",
	constitutionDate: "",
	countryTaxResidence: undefined,
	taxIdentification: "",
	ocupation: "",
	employerName: "",
	hasPRP: false,
	prp: "",
	bankDeposits: "",
	bankAddress: "",
	biC_SWIFT: "",
	iban: "",
	american: false,
	notNIFReason: 0,
	notNIFDetailReason: "",
	legalForm: "",
	incorporationDate: "",
	constitutionPlace: "",
	jurisdiction: "",
	webPage: "",
	contactPerson: "",
	commercialRegister: "",
	activityName: "",
	operationCountries: "",
	organism: false,
	regulationOrganism: "",
	webRegulator: "",
	regulatoryRecord: "",
	contributor: false,
	marketName: "",
	marketCountry: "",
	countryRegulator: "",
	marketWeb: "",
	marketRegistry: "",
	fatca: "",
	textoFatca: "",
	idContract: 0,
	sector: "",
	source: "",
	incomes: "",
	situation: "",
	notificationsEnabled: true,
};

export const emptyInvestorErrors: InvestorErrorsDTO = {
	name: false,
	lastName: false,
	secondLastName: false,
	birthDate: false,
	birthPlace: false,
	nationality: false,
	entityNationality: false,
	mainResidence: false,
	mainResidenceCity: false,
	mainResidencePostalCode: false,
	mainResidenceCountry: false,
	emailContact: false,
	phone: false,
	documentType: false,
	document: false,
	taxResidence: false,
	taxResidenceCity: false,
	taxResidencePostalCode: false,
	countryTaxResidence: false,
	ocupation: false,
	employerName: false,
	prp: false,
	bankDeposits: false,
	bankAddress: false,
	iban: false,
	biC_SWIFT: false,
	situation: false,
	incomes: false,
	source: false,
	sector: false,
	lei: false,
	documentExpiration: false,
	documentFormat: false,
	notValidExpirationDate: false,
	phonePrefix: false,
	phoneNumber: false,
	legalForm: false,
	entityType: false,
	docValidThru: false,
	constitutionDate: false,
	constitutionPlace: false,
	jurisdiction: false,
	socialAddress: false,
	socialAddressCity: false,
	socialAddressPostalCode: false,
	socialAddressCountry: false,
	commercialRegister: false,
	cif: false,
	lastPatrimony: false,
	operationCountries: false,
	regulationOrganism: false,
	countryRegulator: false,
	webRegulator: false,
	regulatoryRecord: false,
	marketName: false,
	marketCountry: false,
	marketWeb: false,
	marketRegistry: false,
	invalidNameFormat: false,
	invalidLastNameFormat: false,
	invalidSecondLastNameFormat: false,
	invalidEmailFormat: false,
	legalFormFormat: false,
}

export const emptyInvestorStatus: PhysicalInvestorStatus = {
	id: 0,
	idContract: 0,
	status1_1: false,
	status1_2: false,
	status1_3: false,
	status2: 0,
	status3: "",
	status4: false,
	status5: false
}

export const emptyLegalInvestorStatus: LegalInvestorStatus = {
	id: 0,
	idContract: 0,
	status1: 0,
	status1_12_1: false,
	status1_12_2: false,
	status1_12_3: false,
	status2: false,
	status3_1: false,
	status3_2: false,
	status3_3: false,
	status4: 0,
	status5: "",
	status6: false,
	status7: false
}


export const emptyRepresentative: Representative = {
	id: 0,
	idContract: 0,
	name: "",
	lastName: "",
	documentType: "",
	documentNumber: "",
	documentExpiration: "",
	birthDate: "",
	nationality: "",
	administrator: "",
	administratorType: "",
	isSignatory: false,
	email: "",
	prP5: false,
	namePRP51: "",
	positionPRP51: "",
	namePRP52: "",
	positionPRP52: "",
	taxResidence: "",
	countryTaxResidence: "",
	taxResidenceCity: "",
	taxResidencePostalCode: "",
}

export const emptyRepresentativeErrors: RepresentativeErrors = {
	name: false,
	lastName: false,
	secondLastName: false,
	documentType: false,
	documentNumber: false,
	documentExpiration: false,
	birthDate: false,
	nationality: false,
	administrator: false,
	administratorType: false,
	namePRP51: false,
	positionPRP51: false,
	email: false,
	taxResidence: false,
	countryTaxResidence: false,
	taxResidenceCity: false,
	taxResidencePostalCode: false,
	namePRP52: false,
	positionPRP52: false,
	notValidExpirationDate: false,
	notValidDocument: false,
	notValidEmail: false,
	invalidNameFormat: false,
	invalidLastNameFormat: false,
	invalidSecondLastNameFormat: false,
}

export const emptyFatca: FatcaDTO= {
	id: 0,
	idContract: 0,
}

export const emptyCrs: CrsDTO ={
	id: 0,
	idContract: 0,
}

export const emptyBeneficiary: Beneficiaries = {
	id: 0,
	idContract: 0,
	name: "",
	lastName: "",
	birthDate: "",
	nationality: "",
	countryTaxResidence: "",
	taxResidence: "",
	taxResidenceCity: "",
	taxResidencePostalCode: "",
	fundsSource: "",
	otherFundsSource: "",
	email: "",
	role: "",
	documentType: "",
	nif: "",
	documentExpiration: "",
	participationPercentage: 0,
	hasPRP: false,
	prp: "",
	isBeneficialOwner: false,
}

export const emptyBeneficiaryErrors: BeneficiariesErrors = {
	name: false,
	lastName: false,
	secondLastName: false,
	birthDate: false,
	nationality: false,
	countryTaxResidence: false,
	taxResidence: false,
	taxResidenceCity: false,
	taxResidencePostalCode: false,
	source: false,
	otherSource: false,
	email: false,
	role: false,
	nif: false,
	documentExpiration: false,
	participationPercentage: false,
	percentageLesserThan25: false,
	prp: false,
	notValidExpirationDate: false,
	notValidDocument: false,
	notValidEmail: false,
	invalidNameFormat: false,
	invalidLastNameFormat: false,
	invalidSecondLastNameFormat: false,
}

export const emptyTaxHolder: TaxHolder = {
	id: 0,
	idContract: 0,
	name: "",
	lastName: "",
	taxResidency: "",
	participationPercentage: ""
};

export const emptyTaxHolderErrors = {
	name: false,
	lastName: false,
	taxResidency: false,
	participationPercentage: false
};

export const emptyTestResponses: SuitabilityTestResult = {
	dateOfCompletion: null,
	q1_1: false,
    q1_2: false,
    q1_3: false,
    q1_4: false,
    q1_5: false,
    q2: null,
    q3: null,
    q4: null,
    q5: null,
    q6: null,
    q7: null,
    q8_1_Ops: null,
    q8_1_Vol: null,
    q8_2_Ops: null,
    q8_2_Vol: null,
    q8_3_Ops: null,
    q8_3_Vol: null,
    q8_4_Ops: null,
    q8_4_Vol: null,
    q8_5_Ops: null,
    q8_5_Vol: null,
    q8_6_Ops: null,
    q8_6_Vol: null,
    q9: null,
};

export const emptyTestResponsesErrors: SuitabilityTestErrors = {
	Q1: false,
	Q2: false,
	Q3: false,
	Q4: false,
	Q5: false,
	Q6: false,
	Q7: false,
	Q8_1_Ops: false,
	Q8_1_Vol: false,
	Q8_2_Ops: false,
	Q8_2_Vol: false,
	Q8_3_Ops: false,
	Q8_3_Vol: false,
	Q8_4_Ops: false,
	Q8_4_Vol: false,
	Q8_5_Ops: false,
	Q8_5_Vol: false,
	Q8_6_Ops: false,
	Q8_6_Vol: false,
	Q9: false,
	name: false,
	surname: false,
	dateOfCompletion: false,
	birthDate: false,
	dni: false,
};

export const emptyExternalContractData: ExternalContractData = {
	vehicleId: 0,
	commitment: 0,
	idLanguage: 1,
	idPersonType: 1,
	numSignatories: 1,
	emailAddress: "",
	emailSubject: "Nuevo contrato para completar",
	emailBody: "<p>Estimado:</p><p><br></p><p><strong>Le informamos que tiene un contrato pendiente de completar</strong>. Puede acceder al mismo medianteel enlace que figura al pie del correo.</p><p><br></p><p>Si no ha ingresado previamente a nuestras plataformas, por favor clickee en <strong><u>Olvidé mi contraseña</u></strong> para generar una nueva.</p><p><br></p><p>Ante cualquier consulta o inconveniente, no dude en comunicarse con nosotros. Estaremos encantados de asistirle.</p><p><br></p><p>Atentamente,</p><p><strong>El equipo de Qualitas Funds,</strong></p>",	fillerName: "",
	fillerLastName: ""
};

export const emptyInvestorDocuments: InvestorDocuments = {
	idDocument: null,
	w8BEN: null,
	w9: null,
	tin: null,
	taxResidenceCertificate: null
};

export const emptyPhysicalInvestorDocumentsRequest: PhysicalInvestorDocumentsRequest = {
	bankCertificate: null,
	fundsOriginDocuments: [],
	investorDocuments: []
};

export const emptyContractPhysicalInvestorDocuments: ContractPhysicalInvestorDocuments = {
	idDocument: null,
	fundsOriginDocuments: [],
	bankCertificate: null,
	w8BEN: null,
	w9: null,
	tin: null,
	taxResidenceCertificate: null
};

export const emptyContractLegalInvestorDocuments: ContractLegalInvestorDocuments = {
	articlesOfIncorporation: null,
	statutesOrRegulations: null,
	statutesModification: null,
	representativesDocumentFile: null,
	representativesIdDocuments: [],
	representativesTaxDomicileCertificates: [],
	beneficiariesIdDocuments: [],
	beneficiariesTaxDomicileCertificates: [],
	fundsOriginDocuments: [],
	beneficialOwnershipCertificate: null,
	representativePowerOfAttorney: null,
	bankCertificate: null,
	regulatedEntityRegistry: null,
	taxIdentificationCard: null,
	w8BEN: null,
	w9: null,
	tin: null,
	taxResidenceCertificate: null
};
